<agpr-take-over-panel
    #takeOverPanel
    [id]="id"
    header="Common.dialog.aeoScout"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [validateBeforeClose]="closeValidation$"
    [responsiveWidth]="true"
    [maxPanelWidth]="1550"
    [minPanelWidth]="1200"
    [width]="80"
    [coverNav]="true"
    (visibleChange)="close($event)"
    styleClass="agpr-aeoScoutDialog-takeOver"
>
    <div class="agpr-aeoScoutDialog">
        @if (isLandingPage) {
            <div class="agpr-aeoScoutDialog-landingPage">
                <div class="agpr-aeoScoutDialog-landingPage-prompt">
                    <span
                        class="agpr-aeoScoutDialog-landingPage-prompt-icon fa-kit-duotone fa-agpr-ai-visibility"
                        aria-hidden="true"
                    ></span>
                    <h3 class="agpr-aeoScoutDialog-landingPage-prompt-title">
                        {{ 'Common.dialog.aeoScout.title' | localize }}
                    </h3>
                    <p class="agpr-aeoScoutDialog-landingPage-prompt-subtitle">
                        {{ 'Common.dialog.aeoScout.subtitle1' | localize }}
                    </p>
                    <p class="agpr-aeoScoutDialog-landingPage-prompt-subtitle">
                        {{ 'Common.dialog.aeoScout.subtitle2' | localize }}
                    </p>
                    @if (isProvisioned) {
                        <agpr-textarea-input
                            [id]="id + '_prompt_textarea'"
                            class="agpr-aeoScoutDialog-landingPage-prompt-textarea"
                            ariaLabel="Common.dialog.aeoScout.title"
                            placeholder="Common.dialog.aeoScout.textarea.placeholder"
                            [(ngModel)]="prompt"
                            [rows]="5"
                            [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                        ></agpr-textarea-input>
                        <agpr-button
                            [id]="id + '_getAnswers'"
                            [style]="buttonTypes.primary"
                            [disabled]="!prompt"
                            [tooltip]="prompt ? '' : 'Common.dialog.aeoScout.getAnswers.tooltip'"
                            label="Common.dialog.aeoScout.getAnswers"
                            (click)="getAnswers()"
                        ></agpr-button>
                    } @else {
                        <div class="agpr-aeoScoutDialog-upsell-buttonWrapper">
                            <agpr-button
                                [id]="id + '_upsell_learn_more'"
                                class="agpr-aeoScoutDialog-landingPage-upsell-button"
                                [style]="buttonTypes.primary"
                                label="LandingPage.productFeatureItem.externalLinks.text"
                                (click)="learnMore()"
                            ></agpr-button>
                            <agpr-button
                                [id]="id + '_upsell'"
                                class="agpr-aeoScoutDialog-landingPage-upsell-button"
                                [style]="buttonTypes.primary"
                                label="Common.dialog.aeoScout.upsell.button"
                                (click)="getInTouch()"
                            ></agpr-button>
                        </div>
                    }
                </div>
                <div class="agpr-aeoScoutDialog-landingPage-models">
                    <div class="agpr-aeoScoutDialog-landingPage-models-panel">
                        <span class="agpr-aeoScoutDialog-landingPage-models-intro">{{ 'Common.dialog.aeoScout.models.intro' | localize }}</span>
                        <ul
                            class="agpr-aeoScoutDialog-landingPage-models-list"
                            agprListKeyboardNavigation
                            listOrientation="horizontal"
                            [focusOnChild]="true"
                        >
                            @for (answerEngine of answerEngineOptions; track answerEngine.type) {
                                <li class="agpr-aeoScoutDialog-landingPage-models-listItem">
                                    <a
                                        class="agpr-aeoScoutDialog-landingPage-models-chip"
                                        [ngClass]="{'agpr-aeoScoutDialog-landingPage-models-chip--mini': viewportHeight <= STANDARD_HEIGHT}"
                                        [href]="answerEngine.linkUrl"
                                        target="_blank"
                                        [pTooltip]="answerEngine.label | localize"
                                        tooltipPosition="top"
                                    >
                                        <img
                                            [src]="appBaseHref + (viewportHeight <= STANDARD_HEIGHT ? answerEngine.logoUrl :answerEngine.labelIconUrl)"
                                            aria-hidden="true"
                                            alt=""
                                        />
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        } @else {
            <div class="agpr-aeoScoutDialog-answerPage">
                <div class="agpr-aeoScoutDialog-lhp">
                    <div class="agpr-aeoScoutDialog-question">
                        <h3 class="agpr-aeoScoutDialog-question-title">
                            {{ 'Common.dialog.aeoScout.title' | localize }}
                        </h3>
                        <p class="agpr-aeoScoutDialog-question-subtitle">
                            {{ 'Common.dialog.aeoScout.subtitleFull' | localize }}
                        </p>
                        <agpr-textarea-input
                            [id]="id + '_prompt_textarea'"
                            class="agpr-aeoScoutDialog-question-textarea"
                            ariaLabel="Common.dialog.aeoScout.title"
                            placeholder="Common.dialog.aeoScout.textarea.placeholder"
                            [(ngModel)]="prompt"
                            [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                            [disabled]="isAnswerGenerating"
                            [rows]="5"
                        ></agpr-textarea-input>

                        <div class="agpr-aeoScoutDialog-question-actions">
                            @if (isAnswerGenerating) {
                                <agpr-button
                                    [id]="id + '_getAnswers_abortion'"
                                    [style]="buttonTypes.tertiary"
                                    label="Mention.insightsExplorerTab.quickInsights.stop"
                                    (click)="cancelGetAnswers()"
                                ></agpr-button>

                                <span
                                    [agprLoading]="true"
                                    [agprInlineLoadingIndicator]="true"
                                    [loadingSmallIndicator]="true"
                                    [loadingLightMode]="false"
                                ></span>
                            } @else {
                                <agpr-button
                                    [id]="id + '_getAnswers'"
                                    [style]="buttonTypes.tertiary"
                                    [disabled]="!prompt || prompt === executedPrompt || isAnswerGenerating"
                                    [tooltip]="prompt ? '' : 'Common.dialog.aeoScout.getAnswers.tooltip'"
                                    label="Common.dialog.aeoScout.getAnswers"
                                    (click)="getAnswers()"
                                ></agpr-button>
                            }
                        </div>
                    </div>
                    <agpr-vi-answer-panel
                        class="agpr-aeoScoutDialog-answer"
                        [engines]="answerEngineOptions"
                        [(selectedType)]="selectedEngineType"
                    ></agpr-vi-answer-panel>
                </div>

                <div class="agpr-aeoScoutDialog-rhp">
                    <agpr-right-sidebar
                        class="agpr-aeoScoutDialog-rhp-sidebar"
                        [loading]="isAnswerGenerating"
                    >
                        <agpr-vi-insights-tab
                            [id]="id + '_insightsTab'"
                            [answerEngineTypes]="answerEngineOptions"
                            [prompts]="prompts"
                            [executedPrompt]="executedPrompt"
                            (langSelectionChanged)="selectedLanguage = $event"
                            (brandSelectionChanged)="selectedBrand = $event"
                        ></agpr-vi-insights-tab>

                        <agpr-vi-source-outlets-tab
                            [id]="id + '_outletsTab'"
                            [outletList]="outletList"
                            [loading]="outletListLoading"
                        ></agpr-vi-source-outlets-tab>
                    </agpr-right-sidebar>
                </div>
            </div>
        }
    </div>

    <ng-template #takeOverFooterLeft>
        @if (isLandingPage) {
            <agpr-button
                [id]="id + '_cancelButton'"
                label="Core.button.cancel"
                [style]="buttonTypes.secondary"
                (click)="cancel()"
            ></agpr-button>
        }
    </ng-template>
    <ng-template #takeOverFooterRight>
        @if (!isLandingPage) {
            <agpr-button
                [id]="id + '_doneButton'"
                label="done"
                [style]="buttonTypes.primary"
                (click)="requestClose()"
            ></agpr-button>
        }
    </ng-template>
</agpr-take-over-panel>


